import { Reducer } from 'redux';

import {
  SessionAcceptCurrentNetworkUsagePolicyAction,
  SessionAcceptCurrentNetworkUsagePolicyFulfilledAction,
} from '../../../domains/sessionAcceptCurrentNetworkUsagePolicy/actions.types';
import { SessionEditCurrentNetworkUsagePolicyAction } from '../../../domains/sessionEditCurrentNetworkUsagePolicy/actions.types';
import { SessionLoadCurrentNetworkUsagePolicyAction } from '../../../domains/sessionLoadCurrentNetworkUsagePolicy/actions.types';

import { CurrentNetworkUsagePolicy } from './types';

export type NetworkUsagePolicyAction =
  | SessionLoadCurrentNetworkUsagePolicyAction
  | SessionAcceptCurrentNetworkUsagePolicyAction
  | SessionEditCurrentNetworkUsagePolicyAction;

const initialState: CurrentNetworkUsagePolicy = {
  pending: false,
  fulfilled: null,
  rejected: undefined,
};

const acceptCurrentNetworkUsagePolicy = (
  state: CurrentNetworkUsagePolicy,
  hasUserAcceptedPolicy: SessionAcceptCurrentNetworkUsagePolicyFulfilledAction['payload']
) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...initialState,
    fulfilled: {
      ...state.fulfilled,
      viewerHasAccepted: !!hasUserAcceptedPolicy,
    },
  };
};

const reducer: Reducer<CurrentNetworkUsagePolicy, NetworkUsagePolicyAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.LOAD_CURRENT_NETWORK_USAGE_POLICY_FULFILLED':
      return { ...initialState, fulfilled: action.payload };
    case 'SESSION.LOAD_CURRENT_NETWORK_USAGE_POLICY_PENDING':
      return { ...initialState, pending: true };
    case 'SESSION.LOAD_CURRENT_NETWORK_USAGE_POLICY_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    case 'SESSION.ACCEPT_CURRENT_NETWORK_USAGE_POLICY_FULFILLED':
      return acceptCurrentNetworkUsagePolicy(state, action.payload);
    case 'SESSION.EDIT_CURRENT_NETWORK_USAGE_POLICY_FULFILLED':
      return { ...initialState, fulfilled: action.payload?.networkUsagePolicy ?? state.fulfilled };
    default:
      return state;
  }
};

export default reducer;
